import React, { useEffect, useState } from "react";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import Modal from "@mui/material/Modal";
import checkImage from "../../assests/images/check-circle.png";
import Box from "@mui/material/Box";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomSearchDropdown from "../common/customSearchDropdown";
import { purchaseOrderServices } from "../../services/purchaseOrderServices";
import { isEmptyDash, strToDate } from "../../constant";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import _ from "lodash";
import ConfirmTableListModal from "../common/confirmTableList";
import { packageServices } from "../../services/packageServices";
import { UserObj } from "../../services/localStarage";
  
const initialColumns = [
    { id: "productNumber", label: "Material Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "productNumber", label: "Service Number", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "description", label: "Material Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "description", label: "Service Description", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "unit", label: "Unit", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "totalQuantity", label: "Total Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "deliveredQty", label: "Recieved Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "pendingQty", label: "Pending Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "plantName", label: "Plant Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "netPrice", label: "Unit Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "netPrice", label: "Net Price", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "newValue", label: "New Price", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "INPUT_TEXT" },
    // { id: "netValue", label: "Net Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "netValue", label: "Net Order Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "purchaseRequisition", label: "Purchase Requisition", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "hsnSacCode", label: "HSN Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    { id: "hsnSacCode", label: "SAC Code", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
    // { id: "deliveryDate", label: "Delivery Date", isSort: false, sortLabel: "", isSearchInput: false, inputText: "", formate: "DATE" }
  ];

const style1 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };
function PoModificationCreation(props) {
    const [columns, setColumns] = useState(props?.initialColumns);
    
    const [openpomodificationmodal, setOpenPoModificationModal] = useState(false);
    const [isConfirmTableModalOpen, setIsConfirmTableModalOpen] = useState(false);
    const [modifiedObjArr, setModifiedObjArr] = useState([]);
    const [prNumList, setprNumList] = useState([]);
    const [selectedPR, setSelectedPR] = useState("");
    const [openpomodificationsuccessmodal, setOpenPoModificationSuccessModal] = useState({isOpen: false, text: ""});
    const [selectedPO, setSelectedPO] = useState(null);
    
    const requestPayloadInitials = {
        pageNumber: 1,
        pageSize: 10,
        sortArray: [],
        searchCriteria: [],
    };
    const [alertComponent, setAlertComponent] = useState({
        open: false,
        message: "",
        type: "",
    });
    let navigate = useNavigate();
    const navigateUrl = (param) => {
      navigate(param);
    };
    const handleCloseAlert = (event, reason) => {
        if (reason === "clickaway") {
        return;
        }
        setAlertComponent({ ...alertComponent, open: false });
    };

    const [isLoading, setIsLoading] = useState(false);
    const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
    const [poDetails, setPODetails] = React.useState({});
    const [listing, setListing] = React.useState({
        totalPages: 0,
        currentPage: 1,
        totalItems: 0,
        [props?.lineItemName]: [],
    });
    
    const onSearchSelectChange = (param, selectParamObj) => {
      // console.log(selectParamObj);      
      setSelectedPO(param);                
      if (props?.componentName == "QTY_MODIFICATION") {
          setprNumList(selectParamObj?.prNumbers); 
          setSelectedPR("");
          setListing({
              totalPages: 0,
              currentPage: 1,
              totalItems: 0,
              [props?.lineItemName]: [],
          });
      } 
      setModifiedObjArr([]);
    }
    
    const onPRChange = (e) => { 
      let {name, value} = e.target;    
      setSelectedPR(value);                
      // if (props?.componentName == "QTY_MODIFICATION") {
      //     setprNumList(selectParamObj?.prNumbers);
      // } 
      // setModifiedObjArr([]);
    }
    
  useEffect(() => {
    if (!isEmptyDash(selectedPO?.selectedValue)) {          
      if (props?.componentName == "PRICE_MODIFICATION") {
        getListing(requestPayload); 
        getPODetails(selectedPO?.selectedValue);  
      }    
    }       
    if (props?.componentName == "QTY_MODIFICATION" && !isEmptyDash(selectedPR)) {
      getListing(requestPayload); 
    } 

   
  }, [requestPayload, selectedPO?.selectedValue, selectedPR]);

  const getListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    
    let promise = "";
    if (props?.componentName == "PRICE_MODIFICATION") {
      promise = purchaseOrderServices.getPOProductsListing(selectedPO?.selectedValue, param);
    }
    if (props?.componentName == "QTY_MODIFICATION") {
      param += `&prNumber=${selectedPR}`;
      promise = packageServices.getPackageBoq(selectedPO?.selectedValue, param);
    }

    promise.then((res) => {
      if (res.data.success === true) {
        setListing(res?.data?.data);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;

    for (let i = 0; i < columnsInit.length; i++) {
      columnsInit[i].sortLabel = "";
      if (i == index) {
        // console.log(i, sortBy, sortOrder);
        columnsInit[i].sortLabel = newSortLael;
      }
    }

    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
    // console.log(requestPayloadInit, columnsInit, index);
  }

  const getPODetails = (param) => {
    setIsLoading(true);
    let url = `/${param}`;
    let promise = purchaseOrderServices.getPurchaseOrderListing(url);
    promise.then((res) => {
      if (res.data.success === true) {
        let columnsInit = _.cloneDeep(props?.initialColumns);
        if (res.data.data.poCategory == "Service") {
          _.remove(columnsInit, function (ele) {
            return (
              ele.label == "Material Number" ||
              ele.label == "Material Description" ||
              ele.label == "Net Price" ||
              ele.label == "Net Order Value" ||
              ele.label == "HSN Code"
            );
          });
        }

        if (res.data.data.poCategory == "Supply") {
          _.remove(columnsInit, function (ele) {
            return (
              ele.label == "Service Number" ||
              ele.label == "Service Description" ||
              ele.label == "Unit Price" ||
              ele.label == "Net Value" ||
              ele.label == "SAC Code"
            );
          });
        }
        setPODetails(res.data?.data);
        setColumns(columnsInit);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }

  const onInputChange = (value, i, keyName) => {
    let listingInit = _.cloneDeep(listing);
    let modifiedObjArrInit = _.cloneDeep(modifiedObjArr);
    let isExist = false;
    listingInit[props?.lineItemName][i][keyName] = value;
    // selectedPOArrInit[i]["totalValue"] = Number(value) * Number(selectedPOArrInit[i]["netPrice"]);
    for (let index = 0; index < modifiedObjArrInit.length; index++) {
      if (modifiedObjArrInit[index]?._id == listingInit[props?.lineItemName][i]["_id"]) {
        modifiedObjArrInit[index]["newValue"] = value;
        isExist = true;
      }
    }
    if (isExist == false) {
      modifiedObjArrInit.push(listingInit[props?.lineItemName][i]);      
    }
    setListing(listingInit);
    setModifiedObjArr(modifiedObjArrInit);
  };
   
  const submitClk = (dataArr) => {
    // setOpenPoModificationModal(true);
    let arr = [];
    let bodyData = {};
    let promise = "";
    
    if (props?.componentName == "PRICE_MODIFICATION") {
      for (let i = 0; i < dataArr.length; i++) {
        let obj = {
          "productId": dataArr[i]?._id,
          "requestedPrice": dataArr[i]?.newValue
        };
        arr.push(obj);
      }
      bodyData["purchaseOrderId"] = selectedPO?.selectedValue;
      bodyData["products"] = arr;
      promise = purchaseOrderServices?.poPriceModification(bodyData);
    }

    if (props?.componentName == "QTY_MODIFICATION") {
      for (let i = 0; i < dataArr.length; i++) {
        let obj = {
          "boqId": dataArr[i]?._id,
          "requestedQuantity": dataArr[i]?.newValue
        };
        arr.push(obj);
      }
      bodyData["packageId"] = selectedPO?.selectedValue;
      bodyData["boqs"] = arr;
      promise = packageServices?.poQtyModification(bodyData);
    }
    
    // console.log(bodyData); 
    setIsLoading(true); 
    promise.then((res) => {
      if (res.data.success === true) {
        setIsConfirmTableModalOpen(false);
        setOpenPoModificationSuccessModal({isOpen: true, text: `${res.data?.message}`});
        setTimeout(() => {
          setOpenPoModificationSuccessModal({isOpen: false, text: ""});  
          navigateUrl(`/admin/po-modification-list`);        
        }, 2000);
      } else {
        setAlertComponent({ open: true, type: "error", message: `No Data Found ` });
      }
    })
      .catch(function (error) {
        // console.log(error);
        setAlertComponent({ open: true, type: "error", message: `${error?.response?.data?.message}` });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  
  const closeConfirmTableModal = () => {
    setIsConfirmTableModalOpen(false); 
  }
  
  const openConfirmTableModal = () => {
    if (modifiedObjArr?.length < 1) {
      setAlertComponent({ open: true, type: "error", message: `Please edit atleast one line-item.` });      
    }
    setIsConfirmTableModalOpen(true); 
  }

  return (
   <>
        <div className="login-forms">
            <div className="text-centers">
                <div className="po_modification_detail">
                <h5 className="row_detail_heading">PO Modification Request  </h5>
                </div>
                <div class="required_react_vendor_block_dashboard d-flex">
                  <div>
                    {(props?.componentName == "PRICE_MODIFICATION") && <label class="row_div_box_select_dashboard">Purchase Order</label>}
                    {(props?.componentName == "QTY_MODIFICATION") && <label class="row_div_box_select_dashboard">Package Code</label>}
                    <div class="dashboard_site_select">
                    {(props?.componentName == "PRICE_MODIFICATION") && <CustomSearchDropdown 
                        listingArrName="purchaseOrders"
                        onSearchSelectChange={onSearchSelectChange}
                        promiseRequest={purchaseOrderServices?.getPendingPOListing}
                        additionalData={{
                            lableKeyName1: "poNumber",
                            lableKeyName2: "",
                            valueKeyName: "_id",
                        }} 
                        isDisable={false}  
                        defaultValue={selectedPO}           
                    />}
                    {(props?.componentName == "QTY_MODIFICATION") && <CustomSearchDropdown 
                        listingArrName="packages"
                        onSearchSelectChange={onSearchSelectChange}
                        promiseRequest={packageServices?.getPackageListing}
                        extraPromiseParam={`selfAssignee=true`}
                        additionalData={{
                            lableKeyName1: "packageCode",
                            lableKeyName2: "",
                            valueKeyName: "_id",
                        }} 
                        isDisable={false}  
                        defaultValue={selectedPO}           
                    />}
                        </div>
                      </div>        
                        {(props?.componentName == "QTY_MODIFICATION") && <div style={{marginLeft: "10px"}}>     
                          <label class="row_div_box_select_dashboard">PR Number</label>                       
                          <select class="form-select vendor_lr_dashboard dashboard_site_select" aria-label="Default select example" 
                          onChange={onPRChange}
                          value={selectedPR}
                          fdprocessedid="v0ghl">
                            <option value={""}>Please Select</option>
                            {prNumList?.map((ele, i) => <>
                              <option value={ele} >{ele}</option>
                            </>)}
                              
                              </select>
                        </div>}
                            
                    </div>
                        <div className="maine_row1_detail_page">
                            <div class="listing_po_modification_detail_row">
                                        <div class="listing_project_block_2_1">
                                            <div class="listing_project_block_3">
                                            <p class="project_code_texts_creationlisbv"><b>Request Date</b></p><p class="block_detail_listing"> {strToDate(new Date())}</p>
                                            </div>
                                        </div>
                            </div>
                        </div>
            <div>
              
               {(props?.componentName == "PRICE_MODIFICATION") && <h6 className="boq_text_project_block">Products</h6>}
                {(props?.componentName == "QTY_MODIFICATION") && <h6 className="boq_text_project_block">BOQ</h6>}
                
            <div className="listing_main" style={{ overflowX: "scroll", marginTop: "15px" }}>
                    <table>
                    <thead>
                        <tr>
                        <th className="vendor_tabels">
                            <input type="checkbox" />
                        </th>
                        {columns.map((column, index) => (<>
                            <th className="vendor_tabels ">
                            <div className="PoDetailTableHeading">
                                <div className="d-flex">
                                <p>{column?.label}</p>
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                    {(column.sortLabel != "asc") && <img src={topArrow} />}
                                    {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                    {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                    {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                                </div>
                            </div>
                            </th>
                        </>))}
                        </tr>
                    </thead>
                    
                  <tbody style={{ overflowY: "scroll", width: "200px" }}>
                        {listing[props?.lineItemName].length < 1 && <>
                        <tr>
                            <td colSpan={8} className="text-center list-no-data">No Data Found</td>
                        </tr>
                        </>}
                        {listing[props?.lineItemName]?.map((productData, i) => (<>
                        <tr className="maine_tr_vendor" key={productData["_id"]}>
                            <td key={`${productData["_id"]}-${i}`}>
                                <input type="checkbox" />
                            </td>
                            {columns.map((column, j) => (column?.formate == "TEXT") ?
                            <td>{productData[column?.id]}</td> : (column?.formate == "INPUT_TEXT") ?
                                <td  key={`${productData["_id"]}-${i}`}>
                                    <input type="number" class="form-control form-ha" 
                                        onChange={(e) => onInputChange(e.target.value, i, column?.id)} 
                                        value={productData?.[column?.id]} 
                                    />
                                </td> : (column?.formate == "RATE") ?
                                    <td> ₹{isEmptyDash(productData[column?.id]) ? 0 : productData[column?.id]} </td> : (column?.formate == "DATE") ?
                                    <td>{strToDate(productData[column?.id])}</td> : null)}
                        </tr>
                        </>))}

                    </tbody>
                    {/* <tbody>
                        <tr className="maine_tr_vendor">
                        <td>
                            <input type="checkbox" />
                        </td>

                        <td className="block_solar">00701</td>
                        <td><input type="text" class="form-control form-ha"  placeholder="Solar development " disabled/></td>
                        <td><input type="text" class="form-control form-ha" placeholder="GHJ134" disabled /></td>
                        <td><input type="text" class="form-control form-ha" placeholder="34"  disabled/></td>
                        <td><input type="text" class="form-control form-ha" placeholder="Kgs"disabled /></td>
                        <td><input type="text" class="form-control form-ha" placeholder="2" /></td>
                        <td><input type="text" class="form-control form-ha" placeholder="0"disabled /></td>
                        <td><input type="text" class="form-control form-ha" placeholder="0"disabled/></td>
                        
                        </tr>
                    
                    </tbody> */}
                    </table>
                </div>
            </div>
            {(modifiedObjArr?.length > 0) && <div className="po_modification_all_btn">
                <button onClick={() => navigateUrl(`/admin/po-modification-list`)}  className="btn btn-danger">Cancel</button>
                <button onClick={openConfirmTableModal} className="btn btn-success">Submit</button>
            </div>}
            
                <Modal
                    open={openpomodificationsuccessmodal?.isOpen}
                    onClose={() => setOpenPoModificationSuccessModal({isOpen: false, text: ""})}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style1} className="modal_react_controlpanel_employees">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                        <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        fdprocessedid="kum8iho"
                        onClick={() => setOpenPoModificationSuccessModal({isOpen: false, text: ""})}
                        ></button>
                    </div>
                    <div class="modal-bodys">
                        <img src={checkImage} alt="" />
                        <p class="project_Manager_bidding">
                        {openpomodificationsuccessmodal?.text}
                        </p>
                        
                        <div className="all_btn_modal_listing">
                        <button
                          className="btn btn-success"
                          onClick={() => setOpenPoModificationSuccessModal({isOpen: false, text: ""}) }
                        >
                            Ok 
                        </button>
                        </div>
                    </div>
                    </Box>
                </Modal>
                    {/* Po modification Detail with success modal */}
            </div>
        </div>
        
        <ConfirmTableListModal 
          isConfirmTableModalOpen={isConfirmTableModalOpen}
          closeConfirmTableModal={closeConfirmTableModal}
          headerText="Do you want to continue? "
          tableText={""}
          tableColumn={columns}
          tableData={modifiedObjArr}
          submitAction={submitClk}
        />

        <AlertComponent
            alertComponent={alertComponent}
            handleClose={handleCloseAlert}
        />
        <Backdrop
            sx={{
            color: "#fff",
            zIndex: (theme) => 999999,//theme.zIndex.drawer + 1,
            }}
            open={isLoading}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
   </>
  )
}

export default PoModificationCreation